module.exports = __webpack_public_path__ + "media/images/athletes/933-fd8b17707a1c4faa5b218c161668305f.png";